import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { NavigationStart, Router, RouterModule } from '@angular/router';
import { Subscription, filter } from 'rxjs';

@Component({
  selector: 'app-info-center-layout',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './info-center-layout.component.html',
  styleUrl: './info-center-layout.component.scss',
})
export class InfoCenterLayoutComponent implements OnInit, OnDestroy {

  private readonly isBrowser: boolean;
  private routerSub?: Subscription;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    if (!this.isBrowser) return;
    this.routerSub = this.router.events
      .pipe(filter(event => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        if (event.url.includes('/info-center')) {
          window.scroll(0, 0);
        }
      });
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
  }
}
